import { ContentContainer } from '@/components/ContentContainer';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { TermsContent } from '@/components/TermsAndConditionsModal/termsContent';
import styles from './TermsAndConditionsPage.module.css';

export const TermsAndConditionsPage = () => {
  return (
    <main className={styles.page}>
      <Header />
      <ContentContainer className={styles.content}>
        <h1 className={styles.title}>Terms & Conditions</h1>
        <section className={styles.terms} aria-label="Terms and conditions content">
          <TermsContent />
        </section>
      </ContentContainer>
      <ContentContainer>
        <Footer />
      </ContentContainer>
    </main>
  );
};
